<template>
	<div
		class="group w-full rounded-md border transition duration-300"
		:class="[
			isSelected
				? `is-selected pointer-events-none cursor-default partner-${partnerName}`
				: `cursor-pointer partner-${partnerName}`,
		]"
		@click="selectThis"
	>
		<div class="flex px-3.5 py-3">
			<div class="flex w-full flex-col gap-1">
				<div
					class="label-highlight font-medium leading-none transition duration-300"
				>
					{{ label }}
				</div>
				<div
					class="desc-highlight text-sm leading-none transition duration-300"
				>
					{{ desc }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
interface Props {
	label: string
	desc?: string
	isSelected?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	desc: 'desc',
	isSelected: false,
})

const emit = defineEmits<{
	(e: 'onSelected', label: string): void
}>()

const { partnerName } = useGetPartnerName()

const selectThis = () => {
	emit('onSelected', props.label)
}
</script>

<style scoped>
/* Base rule for any partner container: sets up color defaults */
[class*='partner-'] {
	--partner-brand: theme('colors.sky.600');
	--partner-hover: theme('colors.sky.600');
	--partner-text-label: theme('colors.gray.700');
	--partner-text-desc: theme('colors.gray.625');
}

/* Whitelabel partner overrides */
.partner-carsales {
	--partner-brand: theme('colors.carsales.primary');
	--partner-hover: theme('colors.carsales.primary');
}

.partner-erinliving {
	--partner-brand: theme('colors.erinliving.primary');
	--partner-hover: theme('colors.erinliving.primary');
}

/* State & Child Styles */
[class*='partner-'] .label-highlight {
	color: var(--partner-text-label);
}

[class*='partner-'] .desc-highlight {
	color: var(--partner-text-desc);
}

/* Hover State (Only active when NOT selected) */
[class*='partner-']:not(.is-selected):hover {
	border-color: var(--partner-hover) !important;
}
[class*='partner-']:not(.is-selected):hover .label-highlight,
[class*='partner-']:not(.is-selected):hover .desc-highlight {
	color: var(--partner-brand);
}

/* Selected State */
[class*='partner-'].is-selected {
	@apply border-2 !important;
	border-color: var(--partner-brand) !important;
	background-color: var(--partner-brand) !important;
	margin: -1px;
}
[class*='partner-'].is-selected .label-highlight,
[class*='partner-'].is-selected .desc-highlight {
	@apply text-white !important;
}
</style>
